import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/navigation';

import { FormattedMessage } from '@flipster/i18n';
import { SpinnerBox } from '@flipster/react/design-system/spinner';
import { EmptyStateIconography } from '@flipster/react/graphic-assets/iconography/EmptyStateIconography';
import { useBreakpoint } from '@flipster/react/misc/responsive/index';
import { css } from '@flipster/styled-system/css';
import { grid, vstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { RewardEvent } from '@flipster/utils/segment/events/reward';
import webviewHandler from '@flipster/utils/webview-handler';

import { useIsWebview } from '../../../shared/webview';
import { promotionListBunja } from './state';

export const PromotionList = () => {
  const router = useRouter();
  const { isDesktop } = useBreakpoint();

  const webview = useIsWebview();
  const { promotionsAtom, isPromotionLoadingAtom } = useBunja(promotionListBunja);
  const promotions = useAtomValue(promotionsAtom);
  const isPromotionLoading = useAtomValue(isPromotionLoadingAtom);

  const showablePromotions = webview
    ? promotions
    : promotions.filter((promotion) => promotion.webLink?.startsWith('https'));

  if (isPromotionLoading) return <SpinnerBox size={40} css={{ minH: 300 }} />;

  return (
    <section className={css({ pb: 56, px: { base: 16, smallDesktop: 0 } })}>
      {showablePromotions.length > 0 ? (
        <ul
          className={grid({
            gap: { base: 8, tablet: 16 },
            columns: { base: 1, tablet: 2 },
            mt: 16,
            justifyContent: 'center',
          })}
        >
          {showablePromotions.map((promotion) => (
            <li className={css({ overflow: 'hidden', rounded: 8, lineHeight: 0 })} key={promotion.id}>
              <button
                type='button'
                onClick={() => {
                  segment.track(RewardEvent.RewardHubBottomBannerClick, { image_name: promotion.title });
                  // 앱 내 이동
                  let page = promotion.webLink ?? '';
                  const appLink = promotion.appLink ?? '';
                  if (webview && appLink) {
                    if (URL.canParse(appLink)) {
                      const url = new URL(appLink);
                      url.searchParams.append('webview', 'true');
                      page = url.toString();
                    } else {
                      page = appLink;
                    }
                  }
                  webviewHandler.postMessage({ action: 'link', params: { page } }, () => router.push(page));
                }}
                aria-label={promotion.title}
                className={css({ lineHeight: 0 })}
              >
                <img
                  src={isDesktop ? promotion.desktopImage : promotion.mobileImage}
                  alt={promotion.title}
                  className={css({ w: '100%', h: 'auto' })}
                />
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <div className={vstack({ gap: 12, mt: 80, color: 'content.default.level-2' })}>
          <EmptyStateIconography size={40} />
          <p className={css({ textStyle: 'Text/S/Regular' })}>
            <FormattedMessage id='Reward_hub.r260128.Promotion_no_active' />
          </p>
        </div>
      )}
    </section>
  );
};
